if (ht.CentralExchange) {
  $('#CentralMessagingInit').each(function () {
    var opts = $(this).metadata().CentralMessagingManagerOpts;
    ht.CentralMessagingManager.init(opts);
  });
}
